import { getMinimumLaunchBalance } from './businessPaymentRules';

/**
 * Parses a formatted account balance string (e.g. "$10.00") to a number.
 */
export const parseAccountBalance = (balance) => {
  if (balance === null || balance === undefined || balance === '') {
    return 0;
  }
  const normalized = String(balance).replace(/[$,\s]/g, '');
  const parsed = parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * Resolves the minimum launch balance from API-backed business state.
 */
export const resolveMinimumLaunchBalance = getMinimumLaunchBalance;

/**
 * True when balance meets or exceeds the minimum funding threshold (>=).
 */
export const hasMinimumLaunchBalance = (balance, business) => {
  const minimum = resolveMinimumLaunchBalance(business);
  return minimum !== null && parseAccountBalance(balance) >= minimum;
};

/**
 * Offer-flow gate: account must be funded to at least the minimum before applying a promo code.
 */
export const canApplyPromoInOfferFlow = (balance, business) => {
  return hasMinimumLaunchBalance(balance, business);
};
